<template>
	<v-card class="panel-main" color="panel_main">
		<v-card-title class="py-2 d-flex align-center justify-space-between">
			{{ $t("SPREADING_COMPACTION") }}
		</v-card-title>
		<v-card-actions class="panel-main-item">
			<v-btn class="add-btn" variant="flat" color="primary" rounded @click="onAdd">
				<template v-slot:prepend>
					<v-icon size="24">mdi-plus</v-icon>
				</template>
				{{ $t("ADD") }}
			</v-btn>
		</v-card-actions>

		<div class="list mx-3 mb-3">
			<v-card-actions v-for="item in spreadingCompactions" :key="item.id" class="py-0"
				:style="item.id === selectedId ? 'background-color: #0064BA;' : ''">
				<v-btn variant="text" icon size="24" @click.stop="onToggleVisible(item.id)" class="ml-0">
					<v-icon>
						{{ item.visible && item.execution.status === 'success' ? 'icon:View' : 'icon:View-Off' }}
					</v-icon>
				</v-btn>
				<div class="label-wrapper" @click="onSelect(item.id)">
					<ListItemLabel :text="item.name" />
				</div>
				<!-- Job state, like an uploading asset: spinner while the server calculates, alert on failure -->
				<v-progress-circular v-if="item.execution.status === 'processing'" class="flex-shrink-0 mr-1"
					indeterminate size="16" width="2" color="primary" />
				<v-icon v-else-if="item.execution.status === 'error'" class="flex-shrink-0 mr-1" size="16"
					color="error">mdi-alert-circle</v-icon>
				<v-menu transition="slide-y-transition">
					<template v-slot:activator="{ props }">
						<v-btn variant="text" size="24" icon v-bind="props">
							<v-icon>icon:Overflow-Menu-Vertical</v-icon>
						</v-btn>
					</template>
					<v-list density="compact">
						<v-list-item :disabled="item.execution.status !== 'success'" @click="onExport(item.id)">
							<v-icon class="mr-4">icon:Export</v-icon>
							<span style="font-size: 13px;">{{ $t("EXPORT_AS") }}</span>
						</v-list-item>
						<v-list-item :disabled="item.execution.status !== 'success'"
							@click="onExportToGroupware(item.id)">
							<v-icon class="mr-4">icon:Upload</v-icon>
							<span style="font-size: 13px;">{{ $t("SAVE_TO_GROUPWARE") }}</span>
						</v-list-item>
						<v-list-item @click="onDelete(item.id)">
							<v-icon class="mr-4">mdi-delete</v-icon>
							<span style="font-size: 13px;">{{ $t("REMOVE") }}</span>
						</v-list-item>
					</v-list>
				</v-menu>
			</v-card-actions>
		</div>
	</v-card>
</template>

<script setup lang="ts">
import ListItemLabel from "@/components/Project/ListItemLabel.vue";
import { useSpreadingCompaction } from "./useSpreadingCompaction";

const spreadingCompaction = useSpreadingCompaction();

const { spreadingCompactions, selectedId } = spreadingCompaction;

function onAdd() {
	spreadingCompaction.create();
}

function onSelect(id: number) {
	spreadingCompaction.select(id);
}

function onToggleVisible(id: number) {
	spreadingCompaction.toggleVisible(id);
}

function onDelete(id: number) {
	spreadingCompaction.remove(id);
}

function onExport(id: number) {
	spreadingCompaction.exportById(id);
}

function onExportToGroupware(id: number) {
	spreadingCompaction.exportToGroupwareById(id);
}
</script>

<style scoped lang="scss">
.label-wrapper {
	flex: 1;
	min-width: 0;
	display: flex;
	cursor: pointer;
}

.list {
	overflow-y: auto;
	overflow-x: hidden;
	scroll-behavior: smooth;
}
</style>
